import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationen from './locales/en.json';

import translationzhCN from './locales/zh-CN.json';

import translationms from './locales/ms.json';



i18n

.use(Backend)

.use(LanguageDetector)

.use(initReactI18next)

.init({
lng: 'en',
fallbackLng: 'en',
debug: false,

interpolation: {
escapeValue: false,
},
resources: {

"en": {
translation: translationen
},

"zh-CN": {
translation: translationzhCN
},

"ms": {
translation: translationms
},



}
});


export default i18n;